d<template>
  <div class="task-overview" v-if="sortedVersions.length > 0">
    <div class="to-versions">
      <DDropdown :isShowDots="false">
        <div class="d-drop-box" slot="title">{{ $t('vue2.task_versions.versions')}} <span class="icon-arrow-down52"></span></div>
        <ul slot="list">
          <li v-for="version in sortedVersions" :key="version.id" @click="selectVersion(version)">
            {{ version.vTitle }}
          </li>
        </ul>
      </DDropdown>
    </div>
    <DModal v-if="activeVersion" :showClose="false" :isBgOverlay="true" :appendToBody="true" @close="activeVersion = null">
      <div class="to-versions__modal text-dark" slot="insertComponent">
        <div class="to-versions__modal__header">
          <div class="to-versions__modal__header__left pad-1-left">
          <select v-model="activeVersionId" @change="selectVersionFromId(activeVersionId)">
            <option v-for="version in sortedVersions" :key="version.id" :value="version.id">
              {{ version.vTitle }}
            </option>
          </select>
            <span class="pad-1-left">
              {{ $t('vue2.task_versions.saved_message') }}: {{ versionDateFormatted }}
            </span>
          </div>
          <div class="to-versions__modal__header__right">
            <DDropdown :isBottomStart="false" v-if="isUserSchoolAdmin">
              <ul slot="list">
                <li class="d-item-warning" @click="setWarningToDelete">
                  <span class="icon-bin"></span> {{ $t('vue2.task_versions.delete_message') }}
                </li>
              </ul>
            </DDropdown>
            <div class="icon__bg-circle ww-modal__header__close" @click="activeVersion = null">
              <span class="icon-cross2"></span>
            </div>
          </div>
        </div>
        <div class="to-versions__modal__body">
          <TaskOverviewUser
            :user="user"
            :version="activeVersion">
          </TaskOverviewUser>
        </div>
      </div>
    </DModal>
    <DModal v-if="isDeleteWarningActive" :appendToBody="true" :isBgOverlay="true" :showClose="false" style="z-index: 999999999">
    <div class="brutto-warning text-dark" slot="insertComponent">
      <div class="brutto-warning__header">
        <h2>{{ $t('vue2.common.are_you_sure_you_want_to_delete') }}?</h2>
        <div class="icon__bg-circle doc-modal__close" @click="isDeleteWarningActive = false">
          <span class="icon-cross2"></span>
        </div>
      </div>
      <div class="brutto-warning__body">
        <svg class="tw-icon tw-icon--red" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
             stroke-linecap="round" stroke-linejoin="round">
          <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"/>
          <line x1="12" y1="9" x2="12" y2="13"/>
          <line x1="12" y1="17" x2="12.01" y2="17"/>
        </svg>
        <h4>{{ $t('vue2.task_versions.confirm_delete_message') }} {{ activeVersion.vTitle }}?</h4>
        <p class="text-explainer">
          {{ $t('vue2.task_versions.delete_warning_message') }}
        </p>
      </div>
      <div class="brutto-warning__footer">
        <button @click="isDeleteWarningActive = false">{{ $t('vue2.common.cancel') }}</button>
        <button class="bttn bttn--warning bttn-danger bttn-primary--small" @click="deleteVersion" :class="[{'bttn--loading': isSaving}]">
          {{ $t('vue2.common.delete') }}
        </button>
      </div>
    </div>
  </DModal>

  </div>
</template>

<script>
import eventbus from '../../../eventbus'
import docendo from '../../../docendo'
import Loader from '../../common/Loader'
import TaskOverviewUser from './TaskOverviewUser'
import DModal from '../../common/DModal'
import DDropdown from '../../common/DDropdown'
import moment from 'moment'

export default {
  components: {DDropdown, DModal, Loader, TaskOverviewUser},
  props: {
    user: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      isSaving: false,
      isLoading: false,
      versions: [],
      activeVersion: null,
      activeVersionId: null,
      isDeleteWarningActive: false,
      isDeleting: false,
      newVersionTitle: ''
    }
  },
  computed: {
    userId () {
      return this.user ? this.user.id : null
    },
    schoolId () {
      return this.$store.getters.schoolId
    },
    schoolYearId () {
      return this.$store.getters.schoolYearId
    },
    versionDateFormatted () {
      const date = this.activeVersion ? this.activeVersion.created_at : moment()
      return moment(date).format('LLL')
    },
    sortedVersions () {
      return this.versions.sort((a, b) => {
        return new Date(b.created_at) - new Date(a.created_at)
      }).filter(version => version.id).map(version => {
        return {
          ...version,
          vTitle: version.title ? version.title : moment(version.created_at).format('LLL')
        }
      })
    },
    theUser () {
      return this.$store.state.user
    },
    isPermissionsActivatedForSchool () {
      return this.$store.getters.isPermissionsActivatedForSchool
    },
    userPermissions () {
      return this.$store.getters.userPermissions
    },
    isUserSchoolAdmin () {
      return this.userHasPermission('can_manage_school')
    }
  },
  watch: {
    schoolId () {
      this.readVersions()
    },
    schoolYearId () {
      this.readVersions()
    },
    user () {
      this.readVersions()
    }
  },
  methods: {
    userHasPermission (permission) {
      if (!this.theUser) {
        return false
      }
      if (this.isPermissionsActivatedForSchool) {
        return this.userPermissions.indexOf(permission) > -1 || this.theUser.admin
      } else {
        return true
      }
    },
    readVersions () {
      if (!this.schoolYearId || !this.schoolId || !this.userId) {
        return
      }
      this.isLoading = true
      docendo.readTaskOverviews(this.schoolId, this.schoolYearId, this.userId, success => {
        this.isLoading = false
        if (success.status === 'error') {
          eventbus.toast = {text: success.message, success: false}
          return
        }
        this.versions = success
      }, failure => {
        this.isLoading = false
        eventbus.toast = {text: 'Something went wrong', success: false}
      })
    },
    selectVersion (version) {
      this.activeVersion = version
      if (version) {
        this.activeVersionId = version.id
      } else {
        this.activeVersionId = null
      }
    },
    selectVersionFromId (id) {
      const idx = this.sortedVersions.findIndex(version => version.id === id)
      this.selectVersion(this.sortedVersions[idx])
    },
    setWarningToDelete () {
      this.isDeleteWarningActive = true
    },
    deleteVersion () {
      this.isDeleting = true
      docendo.deleteTaskOverview(this.schoolId, this.schoolYearId, this.userId, this.activeVersion.id, success => {
        this.isDeleteWarningActive = false
        this.isDeleting = false
        if (success.status === 'error') {
          eventbus.toast = {text: success.message, success: false}
          return
        }
        eventbus.toast = {text: 'Deleted', success: true}
        const idx = this.versions.findIndex(version => version.id === success.id)
        this.versions.splice(idx, 1)
        this.activeVersion = null
      }, failure => {
        eventbus.toast = {text: 'Something went wrong', success: false}
      })
    },
    saveVersion () {
      this.isSaving = true
      docendo.saveTaskOverview(this.schoolId, this.schoolYearId, this.userId, this.newVersionTitle, success => {
        this.isSaving = false
        this.newVersionTitle = ''
        if (success.status === 'error') {
          eventbus.toast = {text: success.message, success: false}
          return
        }
        eventbus.toast = {text: 'Saved', success: true}
        this.versions.push(success)
        this.activeVersion = success
      }, failure => {
        eventbus.toast = {text: 'Something went wrong', success: false}
      })
    }
  },
  mounted () {
    this.readVersions()
  }
}
</script>

<style scoped>
.to-versions__version {
  display: flex;
  align-items: center;
}

.to-versions__modal__body {
  border-radius: 4px;
}

.to-versions__modal__header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-radius: 4px 4px 0 0;
  background: #ffffff;
  border-bottom: 1px solid #eee;
  height: 50px;
}

.to-versions__modal__body {
  max-height: calc(100vh - 80px);
  overflow-y: auto;
  width: 100vw;
  max-width: 800px;
  overscroll-behavior: contain;
}

.pad-1-left {
  padding-left: 1rem;
}

.to-versions__modal__header__left,
.to-versions__modal__header__right {
  display: flex;
  align-items: center;
}

.icon__bg-circle.ww-modal__header__close {
  margin-right: 1rem;
}

</style>



// WEBPACK FOOTER //
// TaskOverview.vue?66300974